import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { NavigationBasePage } from '@shared/pages';
import {
    GeolocationService, UsersService
} from '@shared/services';
import { Constants } from '@shared/models';
import type {
    TNavigationViewModel, TTicket, TTicketStatus, TTimestamp, TUser
} from '@shared/models';

interface IRollCall {
    ticketsToUpdateToEnroute: TTicket[];
    ticketsToUpdateToPending: TTicket[];
}
@Component({
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        IonicModule
    ],
    'selector': 'app-navigation3StartRoute',
    'templateUrl': './navigation3StartRoute.page.html',
    'styleUrls': ['./navigation3StartRoute.page.scss'],
})
export class Navigation3StartRoutePage extends NavigationBasePage implements OnInit, OnDestroy {
    public vm: TNavigationViewModel;
    public drivers: TUser[];
    public selectedDriver;

    constructor( private usersService: UsersService,
        private geolocationService: GeolocationService, injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(Constants.VIEW_NAVIGATION_PAGE3);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        // this.eventsService.publish(Constants.EVENT_NAV_MORE_MENU_CHANGE);

        // const xyz = super.getViewModel();
        this.vm = super.getViewModel() as TNavigationViewModel;
        // super.initialize(this.vm);
        this.vm.step3Complete = false;

        this.selectedDriver = this.sessionService.getUsersFullName;
        this.drivers = await this.usersService.getUsersByRole('driver');

        this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
    }

    public initMoreMenu(): void {
        this.resetPopoverMenu();
        this.pushPopoverMenuItem('Show Tickets');
        this.supplyDebugMenuItems();
        // this.pushPopoverMenuItem('Show Tour', 'show-navigation-3-tour');
        this.moreMenuItemClick(this.handleMenuItemClick);
    }

    public showSetUserButton(): boolean {
        return (this.sessionService.getAccountProfile().showSetUserButton);
    }

    public onToggleDriver(): void {
        let idx = this.drivers.findIndex(user => {
            const fullName = user.firstName + ' ' + user.lastName;
            return (fullName === this.selectedDriver);
        });
        idx = (idx === this.drivers.length - 1) ? 0 : ++idx;
        const user = this.drivers[idx];
        this.selectedDriver = user.firstName + ' ' + user.lastName;
    }

    public onNextClick() {
        if (this.vm.step3Complete) {
            super.setViewModel(this.vm);
            this.router.navigateByUrl('/navigation/navigation4ControlPanel');
        }
    }

    public async onStartRouteClick() {
        try {
            //ptb await this.uxHelperService.showSpinner();
            const rollcall: IRollCall = await this.takeAttendance();
            await this.resetTicketsStatii(rollcall);
            this.showRollCall(rollcall);

            this.vm.route.routeLegs.forEach(leg => leg.status = 'enroute');
            this.vm.trip = await this.tripsService.startTrip(this.vm.tickets, this.vm.route, this.selectedDriver);

            await this.initializeShuttleVector();
            this.vm.step3Complete = true;
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            //ptb await this.uxHelperService.hideSpinner();
        }
    }

    private async initializeShuttleVector() {
        try {
            this.vm.route.shuttle = this.shuttlesService.resetVector(this.vm.route.shuttle);
            this.vm.myVector.tripUid = this.vm.trip.uid;

            const currentCoordinate = await this.geolocationService.getCurrentLocation();
            this.vm.myVector.currentLocation = currentCoordinate.latitude
                ? currentCoordinate
                : this.sessionService.getDealership().address.coordinate;

            await this.shuttleMovementService.startLocationTracking(this.vm.trip.uid, this.vm.route.shuttle);
            await this.shuttlesService.updateShuttleToTraveling(this.vm.route.shuttle.uid);

            // console.log('this.vm.myVector =', this.vm.myVector);
            // console.log('this.vm.route =', this.vm.route);
            await this.routesService.updateRouteToTraveling(this.vm.route);
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        } finally {
            // await this.uxHelperService.hideSpinner();
        }
    }

    private showRollCall(rollcall) {
        const numPresent = rollcall.ticketsToUpdateToEnroute.length;
        const numAbsent = rollcall.ticketsToUpdateToPending.length;

        let x = numPresent.toString();
        x += (numPresent === 1) ? ' ticket has ' : ' tickets have ';
        const presentStr = x + 'been set to enroute and ';
        let y = numAbsent.toString();
        y += (numAbsent === 1) ? ' ticket has ' : ' tickets have ';
        const absentStr = y + 'been set back to pending.';
        this.vm.attendanceSummary = presentStr + absentStr;
    }

    // private takeAttendance() {
    //     const rollcall: any = { 'ticketsToUpdateToEnroute': [], 'ticketsToUpdateToPending': [] };

    //     for (let idx = 0; idx < this.vm.route.selectedTickets.length; idx++) {
    //         const ticket: TTicket = this.vm.route.selectedTickets[idx];

    //         if (ticket.fromDealership) {
    //             // Dropoff
    //             if (ticket.attendance) {
    //                 rollcall.ticketsToUpdateToEnroute.push(ticket);
    //             } else {
    //                 rollcall.ticketsToUpdateToPending.push(ticket);
    //             }
    //         } else {
    //             // Pickup
    //             rollcall.ticketsToUpdateToEnroute.push(ticket);
    //         }
    //     }
    //     return rollcall;
    // }

    private async takeAttendance(): Promise<IRollCall> {
        try {
            const rollcall: IRollCall = { ticketsToUpdateToEnroute: [], ticketsToUpdateToPending: [] };

            this.vm.route.selectedTickets.forEach(ticket => {
                if (ticket.fromDealership) {
                    if (ticket.attendance) {
                        rollcall.ticketsToUpdateToEnroute.push(ticket);
                    } else {
                        rollcall.ticketsToUpdateToPending.push(ticket);
                    }
                } else {
                    rollcall.ticketsToUpdateToEnroute.push(ticket);
                }
            });

            return rollcall;
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
            throw err; // Add this line to throw the error and ensure all code paths return a value.
        } finally {
            // await this.uxHelperService.hideSpinner();
        }
    }

    // private async resetTicketsStatii(rollcall: any) {
    //     const promises = [];
    //     try {
    //         rollcall.ticketsToUpdateToPending.forEach(ticket => {
    //             const idx = this.vm.route.selectedTickets.findIndex(tix => (tix.uid === ticket.uid));
    //             this.vm.route.selectedTickets.splice(idx, 1);

    //             ticket.driver = '';
    //             ticket.status = 'pending';
    //             const p = this.ticketsService.update(ticket);
    //             promises.push(p);
    //         });

    //         rollcall.ticketsToUpdateToEnroute.forEach(ticket => {
    //             ticket.status = 'enroute';
    //             ticket.enrouteDate = this.dateService.now();
    //             const p = this.ticketsService.update(ticket);
    //             promises.push(p);
    //         });

    //         await Promise.all(promises);
    //         // resolve();
    //     } finally {
    //         //
    //     }
    // }

    private async resetTicketsStatii(rollcall: IRollCall) {
        try {
            const promises = [];

            // If the ticket-holder is not at the shuttle station, then reset the ticket status back to 'pending'.
            rollcall.ticketsToUpdateToPending.forEach(ticket => {
                this.updateTicketStatus(ticket, 'pending');
                promises.push(this.ticketsService.update(ticket));
            });

            // If the ticket-holder is at the shuttle station, then update the ticket status to 'enroute'.
            rollcall.ticketsToUpdateToEnroute.forEach(ticket => {
                this.updateTicketStatus(ticket, 'enroute');
                promises.push(this.ticketsService.update(ticket));
            });

            await Promise.all(promises);
        } catch (err) {
            const errorMessage = this.utilsService.extractError(err);
            this.uxHelperService.showAlert('Error', errorMessage);
        }
    }

    private updateTicketStatus(ticket: TTicket, ticketStatus: TTicketStatus) {
        const now = this.dateService.now();
        const idx = this.vm.route.selectedTickets.findIndex(tix => tix.uid === ticket.uid);
        if (ticketStatus === 'pending') {
            this.vm.route.selectedTickets.splice(idx, 1);
            ticket.driver = '';
        }
        ticket.status = ticketStatus;
        if (ticketStatus === 'enroute') {
            ticket.enrouteDate = now;
        }
    }

    // private async showDebugMessage(message: string): Promise<void> {
    //     await this.uxHelperService.showToast('Message = ' + message);
    // }
}
